(() => {
  const termsSelector = '.cart-terms-checkbox';
  const checkoutSelector = 'button[name="checkout"], [tac-co-cloned="true"]';
  const initialized = new WeakSet();
  let syncing = false;

  function sync() {
    if (syncing) return;
    syncing = true;
    try {
      document.querySelectorAll(termsSelector).forEach(terms => {
        const scope = terms.closest('cart-drawer, .cart');
        const form = scope?.querySelector('form');
        if (!scope || !form) return;
        // The full cart's summary controls sit outside its form.
        if (terms.form !== form) terms.setAttribute('form', form.id);
        if (!initialized.has(terms)) {
          terms.checked = false;
          initialized.add(terms);
        }
        // Keep the app's original input and change handler so it owns logging.
        const withdrawal = scope.querySelector('#effectiveAppsAgreeCB');
        const wrapper = withdrawal?.closest('p');
        if (wrapper) {
          wrapper.classList.add('cart-withdrawal-consent');
          wrapper.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) node.remove();
          });
          const termsWrapper = terms.closest('.cart-terms-wrapper');
          if (termsWrapper.nextElementSibling !== wrapper) {
            termsWrapper.after(wrapper);
          }
          if (wrapper.hidden === terms.checked) wrapper.hidden = !terms.checked;
          withdrawal.required = terms.checked;
          if (withdrawal.form !== form) withdrawal.setAttribute('form', form.id);
          if (!terms.checked && withdrawal.checked) {
            withdrawal.checked = false;
            withdrawal.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        const ready = Boolean(terms.checked && withdrawal?.checked);
        scope.querySelectorAll(checkoutSelector).forEach(button => {
          if (button.disabled === ready) button.disabled = !ready;
        });
      });
    } finally {
      syncing = false;
    }
  }

  function allowed(element) {
    const scope = element?.closest('cart-drawer, .cart');
    const terms = scope?.querySelector(termsSelector);
    return !terms || Boolean(terms.checked && scope.querySelector('#effectiveAppsAgreeCB')?.checked);
  }

  // Also guard keyboard submission and the app's cloned checkout button.
  document.addEventListener('click', event => {
    const checkout = event.target.closest(checkoutSelector);
    if (checkout && !allowed(checkout)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      sync();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (!allowed(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      sync();
    }
  }, true);
  document.addEventListener('change', sync);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll(termsSelector).forEach(terms => { terms.checked = false; });
    sync();
  });
  // Snow replaces the drawer contents on each cart update; the app then reinserts
  // its checkbox. Observe both stages without creating another timer per render.
  new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
  sync();
})();
